import React, { Fragment } from 'react'
import { Container, Row, Col, Input, Button, Table } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faPlus, faCheck } from '@fortawesome/free-solid-svg-icons'
import 'bootstrap/dist/css/bootstrap.css';
import ConfirmButton from '../Modal/ConfirmButton';

class ClientInfo extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            edit: false,
            editJSON: '',
            info: (this.props.clientInfo != null && this.props.clientInfo !== '') ? JSON.parse(this.props.clientInfo) : {}
        };

    }

    onChange = (e) => {
        e.persist();
        this.props.log('ClientInfo.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        const [section, field, index] = e.target.name.split('_');

        this.setState(prevState => {
            const sel = prevState;
            if (sel.info[section][index] == null) sel.info[section][index] = {};
            switch (e.target.type) {
                case "checkbox":
                    sel.info[section][index][field] = e.target.checked;
                    break;
                default:
                    sel.info[section][index][field] = e.target.value;
            }
            return sel
        });
    }

    addToSection = (section) => {
        this.props.log('ClientInfo.js/addToSection (section)', section);
        this.setState(prevState => {
            const sel = prevState;
            if (sel.info[section] == null) sel.info[section] = [];
            sel.info[section].push({});
            return sel
        });
    }

    removeFromSection = (section, index) => {
        this.props.log('ClientInfo.js/removeFromSection (section,index)', section, index);
        this.setState(prevState => {
            let sel = prevState;
            sel.info[section].splice(index, 1);
            Object.keys(sel.info).forEach((section) => sel.info[section].length === 0 && delete sel.info[section]);
            return sel;
        });
    }

    onSave = () => {
        this.props.log('ClientInfo.js/onSave');
        this.setState(prevState => {
            let sel = prevState;
            Object.keys(sel.info).forEach((section) => Object.keys(sel.info[section][0]).length === 0 && delete sel.info[section]);
            sel.edit = false;
            sel.editJSON = JSON.stringify(this.state.info);
            return sel;
        }, () => this.props.handleUpdateClientInfo({ info: JSON.stringify(this.state.info) }));
    }

    onEdit = () => {
        this.props.log('ClientInfo.js/onEdit');
        this.setState({
            edit: true,
            editJSON: JSON.stringify(this.state.info)
        })
    }

    formatText = (val, type) => {
        this.props.info('ClientInfo.js/formatText (val, type)', val, type);
        if (val === '' || val == null) return '';
        // this.props.log('ClientInfo.js/formatText (val,type)', val, type);
        switch (type) {
            case "currency":
                return '$' + parseFloat(val).toFixed(2);
            case "time":
                return this.formatAMPM(val);
            case "checkbox":
                return (val) ? <FontAwesomeIcon icon={faCheck} /> : <></>;
            case "phone":
                var cleaned = ('' + val).replace(/\D/g, '');
                var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
                if (match) return <span className="timerLine">{'(' + match[1] + ') ' + match[2] + '-' + match[3]}</span>;
                return null;
            default:
                return val;
        }
    }

    formatAMPM = (date) => {
        this.props.info('ClientInfo.js/formatAMPM (date)', date);
        if (date === '' || date == null) return date;
        var [hours, minutes] = date.split(':').map(item => parseInt(item));
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    onCancelEdit = () => {
        this.props.log('ClientInfo.js/onCancelEdit');
        this.setState({
            edit: false,
            info: JSON.parse(this.state.editJSON),
            editJSON: ''
        })
    }

    displayTables = (parent, parentIndex, serviceColumn, key) => {
        this.props.log('ClientInfo.js/displayTables (parent, parentIndex, serviceColumn, key)', parent, parentIndex, serviceColumn, key);
        const sections = parent.sections.map(section => section.stateSection);
        const infoSections = Object.keys(this.state.info);
        const filteredArray = sections.filter(value => infoSections.includes(value));
        let totalColumns = Math.max(...parent.sections.filter(section => this.state.info[section.stateSection] != null).map(section => section.fields.length));
        if (this.state.edit) {
            return (
                <Fragment key={key + '-edit-' + parentIndex}>
                    {parent.sections.length > 0 ? <Row>
                        <Col className="text-left px-1 mt-2" md={12}><h3>{parent.name}</h3></Col>
                    </Row> : <></>}
                    {parent.sections.map((section, sectionIndex) => {
                        return (<Fragment key={parentIndex + '--' + sectionIndex}>
                            <Row>
                                <Col className="text-left px-2" md={12}>
                                    <h4 className="pt-3">{section.name}</h4>
                                </Col>
                            </Row>
                            {this.state.info[section.stateSection] != null ? this.state.info[section.stateSection].map((entry, index) => (
                                <Row key={'a-'+index} className="adminRow">
                                    <Col md={11}>
                                        {section.fields.map((field, fieldIndex) => (
                                            <Row key={'b-'+index + '-' + fieldIndex}>
                                                <Col key={fieldIndex} md={6} className={field.classNames + ' text-right font-weight-bold'}>
                                                    {field.hint}
                                                </Col>
                                                <Col key={'c-'+fieldIndex} md={6} className={field.classNames + ' text-left'}>
                                                    <Input
                                                        placeholder={field.hint}
                                                        type={field.type}
                                                        ref={input => this[section.stateSection + '_' + field.name + '_' + index] = input}
                                                        name={section.stateSection + '_' + field.name + '_' + index}
                                                        value={this.props.isFieldNull(field.type === 'checkbox' ? '' : entry[field.name])}
                                                        checked={this.props.isFieldNull(field.type === 'checkbox' ? entry[field.name] : '',true)}
                                                        onChange={(e) => this.onChange(e)}>
                                                        {field.options != null && field.type === 'select' ?
                                                            <>
                                                                <option value="">Select</option>
                                                                {field.options.map(option => (
                                                                    <option key={option}>{option}</option>
                                                                ))}
                                                            </>
                                                            : null}
                                                    </Input>
                                                    {field.type === 'checkbox' ? <Input type="text" className="invisible" /> : <></>}
                                                </Col>
                                            </Row>
                                        ))}
                                    </Col>
                                    <Col md={1}>
                                        <ConfirmButton color="danger" onClick={() => this.removeFromSection(section.stateSection, index)}><FontAwesomeIcon icon={faTrashAlt} /></ConfirmButton>
                                    </Col>
                                </Row>
                            )) : <></>}
                            {(section.limit === 0 || this.state.info[section.stateSection] == null || this.state.info[section.stateSection].length < section.limit) ?
                                <Row>
                                    <Col className="text-left px-1" md={12}>
                                        <Button className="my-2" onClick={() => this.addToSection(section.stateSection)} color="primary"><FontAwesomeIcon icon={faPlus} /></Button>
                                    </Col>
                                </Row>
                                : <></>}
                        </Fragment>)
                    }

                    )}</Fragment>
            )
        } else {
            return (
                <Fragment key={key+'-'+parentIndex}>
                    {filteredArray.length > 0 ? <Row>
                        <Col className="text-left px-1 mt-4" md={12}><h3>{parent.name}</h3></Col>
                    </Row> : /*<Row>
                                <Col className="text-left px-1 mt-4" md={12}><h3>{parent.name}</h3><p>No data available</p></Col>
                            </Row>*/ <></>}
                    {parent.headers != null && parent.sections.filter(section => this.state.info[section.stateSection] != null).length > 0 ?
                        <Row><Col className="text-left px-0" md={12}>
                            <Table>
                                {/* {parent.headers != null && parent.sections.filter(section => this.state.info[section.stateSection] != null).length > 0 ? */}
                                <thead>
                                    <tr>
                                        {parent.headers.filter(header => header != null).length > 0 ? <>{serviceColumn ? <th>Service</th> : <></>}{parent.headers.filter(header => header != null).map((header, headerIndex) => (
                                            <th className="text-left px-1" key={parentIndex + '--' + headerIndex}>{header}</th>
                                        ))}</> : <>{serviceColumn ? <th>Service</th> : <></>}
                                            {parent.sections != null && parent.sections.length > 0 && parent.sections[0].fields != null ?
                                                parent.sections[0].fields.map((field, fieldIndex) => (
                                                    <th key={'header-'+fieldIndex}>{field.hint}</th>
                                                ))
                                                : <></>}
                                        </>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* : <>u</>} */}
                                    {parent.sections.map((section, sectionIndex) => (
                                        <Fragment key={sectionIndex}>{this.state.info[section.stateSection] != null ? this.state.info[section.stateSection].map((entry, entryIndex) => (
                                            <tr key={'row-'+entryIndex}>
                                                <>
                                                    {parent.headers != null && parent.headers[0] == null ? <td>{section.name}</td> : (serviceColumn ? <td>{section.name}</td> : <></>)}
                                                    {section.fields.map((field, fieldIndex) => (
                                                        // <Col key={fieldIndex} md={6} className={field.classNames + ' text-right font-weight-bold px-1'}>
                                                        //     {field.hint}
                                                        // </Col>
                                                        <td key={'cell-'+fieldIndex} className={field.classNames + ' text-left px-1'}>
                                                            {this.formatText(entry[field.name], field.type)}
                                                        </td>
                                                    ))}
                                                    {[...Array(totalColumns - section.fields.length).keys()].map((i, index) => (<td key={'empty'+index}>&nbsp;</td>))}
                                                </>
                                            </tr>
                                        )) : <></>}</Fragment>
                                    ))}
                                </tbody>
                            </Table>
                        </Col>
                        </Row> : <></>}
                </Fragment>
            )
        }
    }

    render = () => {
        this.props.info('ClientInfo.js/render');
        const newArr = [];
        //  this.props.clientData.services/*.filter(service => service.services != null)*/.map(service => {
        //     return ({
        //         name: service.name, headers: service.headers.split(',').map(item => item === '' ? null : item), sections: (service.services != null) ? service.services.filter(section => section.fields != null).map(section => {
        //             return ({
        //                 fields: section.fields.map(field => {
        //                     return ({ classNames: '', col: 0, hint: field.column, inputMask: '', name: field.section, type: (field.type != null ? field.type : 'text'), validation: '' })
        //                 }), limit: section.limit, name: section.name, stateSection: section.section
        //             })
        //         }) : []
        //     })
        // }).sort((a, b) => a.name.localeCompare(b.name))
        // return (<></>)
        return (<Container className="px-0 text-left">
            {this.props.companySchema.parents.map((parent, parentIndex) => {
                return this.displayTables(parent, parentIndex, false, 1)
            })}
            {newArr.filter(item => item.sections.length > 0).length > 0 ? <Row>
                <Col className="text-left px-1 mt-2" md={12}><h2>CSSI Services</h2></Col>
            </Row> : <></>}
            {newArr.filter(parent => parent.sections.length > 0).map((parent, parentIndex) => {
                return this.displayTables(parent, parentIndex, true, 2)
            })}
            <Row>
                <Col className="px-1 pt-3">
                    {this.state.edit ?
                        <>
                            <Button onClick={() => this.onSave()} color="success">Save</Button>
                            <Button onClick={() => this.onCancelEdit()} color="secondary">Cancel</Button>
                        </>
                        : <Button onClick={() => this.onEdit()} color="primary">Edit</Button>}
                </Col>
            </Row>
            {this.state.info != null && this.state.info.contacts != null && this.state.info.contacts.filter(contact => contact.notifications).map(contact => contact.email).length > 0 ?
                <Row className="pt-3 text-left">
                    <Col className="font-weight-bold" md={3}>Email List: </Col>
                    <Col md={8}>{this.state.info.contacts != null ? this.state.info.contacts.filter(contact => contact.notifications).map(contact => contact.email).join(', ') : <></>}</Col>
                </Row> : <></>}
        </Container>
        )
    }
}

export default ClientInfo;